// noinspection JSUnresolvedVariable

import {JsonResponseError} from "./JsonResponseError";
import {errorAlert} from "../extensions/Swal";

require('./JsonResponseError');
require('./records');

export class JsonResponse
{
	/** @type {Boolean} */
	success;

	/** @type {any} */
	data;

	/** @type {JsonResponseError|null} */
	error;

	/**
	 * Initialises a new JSON response object.
	 * @param success
	 * @param data
	 * @param error
	 */
	constructor(success, data, error)
	{
		this.success = success;
		this.data = data || {};
		this.error = error || null;

		if (error instanceof JsonResponseError)
			console.log(error);
	}

	/**
	 * Determines if the response has an error.
	 */
	hasError()
	{
		return !!this.error;
	}

	/**
	 * Gets the error message if it exists.
	 * @returns {string|null}
	 */
	errorMessage()
	{
		return this.error ? this.error.message : null;
	}

	/**
	 * Gets the error code if it exists.
	 * @returns {string|number}
	 */
	errorCode()
	{
		return this.error ? this.error.code : null;
	}

	/**
	 * Gets the error data if it exists.
	 * @returns {any}
	 */
	errorData()
	{
		return this.error ? this.error.data : null;
	}

	/**
	 * Shows an alert if an error exists in the response.
	 * @param title An optional title override.
	 * @param text An optional text override.
	 * @param config An optional configuration to pass to the sweetalert.
	 * @returns {boolean}
	 */
	showAlertIfError(title, text, config)
	{
		if (!this.hasError())
			return false;

		errorAlert(title || 'Error Occurred', text || this.error.message || 'Unknown error occured.', config);
		return true;
	}

	/**
	 * Creates a sanitised JSON response from the response value.
	 * @param {any} response
	 * @returns {JsonResponse}
	 */
	static fromResponse(response)
	{
		if (response && 'responseJSON' in response)
		{
			response = response.responseJSON;
			if (response.exception && response.message)
				return new JsonResponse(false, {}, new JsonResponseError('[' + response.exception + ']: ' + response.message, null, response));
		}

		if (!response || !('success' in response))
			return new JsonResponse(false, {}, new JsonResponseError());

		else if ('getResponseHeader' in response)
			return new JsonResponse(false, response, new JsonResponseError(response.status + ' Error: ' + response.statusText.substr(0, 25)));

		if (typeof response.success != 'boolean')
			response.success = !!response.success;

		if (!response.success && !response.error)
			response.error = new JsonResponseError();

		if (!('data' in response))
			response.data = {};

		if (response.error)
			response.error = JsonResponseError.fromObject(response.error);

		let result = new JsonResponse(response.success, response.data, response.error);
		for(let i in response)
			if (response.hasOwnProperty(i))
				result[i] = response[i];

		if (result.data && typeof result.data == 'object' &&
			result.data.recordType && Array.isArray(result.data.records))
		{
			let constructor = window.App.Records[result.data.recordType];
			if (typeof constructor == 'function')
				result.data.records = result.data.records.map((record) => new constructor(record));
		}

		if (result.hasError())
			console.log(result.error);

		return result;
	}
}

window.App = window.App || {};
window.App.JsonResponse = JsonResponse;
